import React from 'react';

import Promotions from './promotions';

const Initial: React.FC = () => (
  <Promotions />
);

export default Initial;
